import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthorizationDesc, Transaction } from '../models';
import { Summary } from '../models/summary';
import { BehaviorSubject, Subject } from 'rxjs';
import { FeatureFlagService } from './feature-flag.service';
import { environment } from 'src/environments/environment';
import { createMerchantReturnUrl } from '../shared/helps/helps';

@Injectable({
    providedIn: 'root',
})
export class AuthService {
    private readonly jwt: JwtHelperService = new JwtHelperService();
    private summary: Summary;
    private tc: any;
    private userInfo: any;
    goBackSource = new Subject();
    transaction: Transaction;
    orderIDSubject = new BehaviorSubject(null);
    goBacknotification$ = this.goBackSource.asObservable();
    orderInfo: AuthorizationDesc;

    constructor(private readonly launchDarkly: FeatureFlagService) {}

    getAndDecode(token: any): any {
        return this.jwt.decodeToken(token);
    }

    set orderID(orderID: string) {
        this.orderIDSubject.next(orderID);
    }

    get orderID() {
        return this.orderIDSubject.getValue();
    }

    get orderID$() {
        return this.orderIDSubject.asObservable();
    }

    getOrderID(): string {
        return this.orderID;
    }

    setSummary(summary: any) {
        this.summary = summary;
    }

    getSummary(): any {
        return this.summary;
    }

    setTC(TC: any) {
        this.tc = TC;
    }

    getTC(): any {
        return this.tc;
    }

    setUserInfo(userInfo: any) {
        this.userInfo = userInfo;
    }

    getUserInfo(): any {
        return this.userInfo;
    }

    setOrderInfo(orderInfo: AuthorizationDesc) {
        this.orderInfo = orderInfo;
    }

    getOrderInfo() {
        return this.orderInfo;
    }

    buildReturnUrl(merchantUrl: string, orderID: string, token: string) {
        if (merchantUrl) return createMerchantReturnUrl(orderID, merchantUrl);

        return `${environment.host}?token=${token}`;
    }

    loadLaunchDarkly = (flagName: string, merchant: string) => {
        return new Promise((resolve, reject) => {
            this.launchDarkly.initFlags(merchant).subscribe({
                next: () => {
                    resolve(this.launchDarkly.getFlagValue(flagName));
                },
                error: (err) => {
                    reject(err);
                },
            });
        });
    };
}
